<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.mobile" prefix-icon="el-icon-search" placeholder="输入手机号查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="5">
        <el-select v-model="params.send_result" @change="onSearch" placeholder="选择发送状态查询" clearable>
          <el-option
            v-for="item in MessageSendStatuList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>

      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)" :min-width="it.key === 'send_content' ? '240' : ''">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import Util from '@/api/util'

export default {
  data () {
    return Backend.initListPage(this, 'message_send_recorder', {
      route_name: '短信发送记录列表',
      MessageSendStatuList: BasicDataHelper.MessageSendStatuList,
      tableColList: [
        {
          key: 'send_time',
          name: '发送时间',
          sortable: true
        },
        {
          key: 'send_result_desp',
          name: '发送状态'
        },
        {
          key: 'user_name',
          name: '用户名'
        },
        {
          key: 'mobile',
          name: '手机号码'
        },
        {
          key: 'send_content',
          name: '发送内容'
        }
      ],
      params: {
        mobile: '',
        send_result: ''
      }
    })
  },

  methods: {
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    }
  }
}
</script>
